import React from 'react';
import { motion } from 'framer-motion';
import { CalendarPlus } from 'lucide-react';
import { Link } from 'react-router-dom';

interface BookCallButtonProps {
  className?: string;
  onClick?: () => void;
}

const BookCallButton: React.FC<BookCallButtonProps> = ({ className = "", onClick }) => {
  if (onClick) {
    return (
      <motion.button
        onClick={onClick}
        className={`gold-gradient-btn flex items-center gap-2 px-12 py-4 rounded-full text-black font-semibold mx-auto ${className}`}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
      >
        <CalendarPlus className="w-5 h-5" />
        <span>Book a Consultation</span>
      </motion.button>
    );
  }

  return (
    <Link to="/contact">
      <motion.button
        className={`gold-gradient-btn flex items-center gap-2 px-12 py-4 rounded-full text-black font-semibold mx-auto ${className}`}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
      >
        <CalendarPlus className="w-5 h-5" />
        <span>Book a Consultation</span>
      </motion.button>
    </Link>
  );
};

export default BookCallButton;